// extracted by mini-css-extract-plugin
export var required = "_ns-0";